import LegalPage, { LegalSection } from "@/pages/LegalPage";

export default function Terms() {
  return (
    <LegalPage title="Terms of Service" lastUpdated="December 2025">
      <p>
        These Terms of Service ("Terms") govern your access to and use of the
        Green Financials website and related services. By using our site or
        submitting a form, you agree to these Terms.
      </p>

      <LegalSection title="1. Who We Are">
        <p>
          Green Financials is a marketing platform operated to help families
          and entrepreneurs explore modern life insurance and wealth-building
          strategies, and to recruit and train new insurance professionals.
          Insurance products are offered exclusively through licensed
          professionals affiliated with us.
        </p>
      </LegalSection>

      <LegalSection title="2. Eligibility">
        <p>
          You must be at least 18 years old and legally capable of entering
          into a binding agreement to use this site or submit any form.
        </p>
      </LegalSection>

      <LegalSection title="3. Not Financial, Legal, or Tax Advice">
        <p>
          The information on this site is provided for general educational
          purposes only and does not constitute financial, legal, tax, or
          insurance advice. Always consult a licensed professional and review
          policy documents before purchasing any insurance product.
        </p>
        <p>
          No guarantees are made about cash value growth, returns, tax
          treatment, or product performance. Policy terms, eligibility, and
          benefits vary by carrier, state, and individual circumstances.
        </p>
      </LegalSection>

      <LegalSection title="4. Consultations & Bookings">
        <p>
          A consultation booking is a request to speak with a licensed
          representative. It does not create a binding agreement, an insurance
          contract, or guaranteed coverage. Coverage is subject to
          underwriting, application, and acceptance by an insurance carrier.
        </p>
      </LegalSection>

      <LegalSection title="5. Recruitment Applications">
        <p>
          Submitting a recruitment application does not guarantee employment,
          contractor status, or any earnings. All commissions, bonuses, and
          income are subject to the agreements you sign with us or our partner
          carriers. Income examples are not promises; results vary based on
          effort, market, and licensing.
        </p>
      </LegalSection>

      <LegalSection title="6. Acceptable Use">
        <p>You agree not to:</p>
        <ul className="list-disc pl-6 space-y-2">
          <li>Submit false, misleading, or impersonating information.</li>
          <li>Attempt to bypass security, scrape, or overload our site.</li>
          <li>
            Use our content, brand, or imagery without prior written
            permission.
          </li>
          <li>Use our services for unlawful or fraudulent activity.</li>
        </ul>
      </LegalSection>

      <LegalSection title="7. Intellectual Property">
        <p>
          All content on this site — including text, graphics, logos,
          photography, and code — is owned by Green Financials or its
          licensors and is protected by copyright and trademark law. You may
          not reproduce or distribute it without written permission.
        </p>
      </LegalSection>

      <LegalSection title="8. Third-Party Services">
        <p>
          Our site uses third-party services such as Calendly (scheduling),
          WhatsApp (messaging), and analytics tools. Your use of those
          services is also governed by their own terms and privacy policies.
        </p>
      </LegalSection>

      <LegalSection title="9. Disclaimers">
        <p>
          The site is provided "as is" without warranty of any kind, express
          or implied. We do not guarantee that the site will be uninterrupted,
          error-free, or completely secure.
        </p>
      </LegalSection>

      <LegalSection title="10. Limitation of Liability">
        <p>
          To the fullest extent permitted by law, Green Financials and its
          affiliates will not be liable for any indirect, incidental, special,
          consequential, or punitive damages, or any loss of profits or
          revenue, arising out of your use of the site.
        </p>
      </LegalSection>

      <LegalSection title="11. Indemnification">
        <p>
          You agree to indemnify and hold harmless Green Financials from any
          claims, damages, or expenses arising from your misuse of the site or
          violation of these Terms.
        </p>
      </LegalSection>

      <LegalSection title="12. Governing Law">
        <p>
          These Terms are governed by the laws of the State of Texas, United
          States, without regard to its conflict-of-law principles. Any
          dispute will be resolved in the state or federal courts located in
          Harris County, Texas.
        </p>
      </LegalSection>

      <LegalSection title="13. Changes to These Terms">
        <p>
          We may update these Terms periodically. Continued use of the site
          after changes are posted constitutes acceptance of the revised
          Terms.
        </p>
      </LegalSection>

      <LegalSection title="14. Contact">
        <p>
          <strong className="text-white">Green Financials</strong>
          <br />
          Email: <span className="text-rolex-light">admingreenfinancials@gmail.com</span>
          <br />
          WhatsApp: +1 (281) 969-6440
        </p>
      </LegalSection>
    </LegalPage>
  );
}
